import { createContext } from 'react';

export type PushStackContextValue = {
    /** Which level is on screen, as an index into the stack's children. */
    activeIndex: number;
    /** The active level reports its height, so the stack can morph to it. */
    onActiveHeight: (height: number) => void;
};

export const PushStackContext = createContext<PushStackContextValue | undefined>(undefined);

/** A level's own position among its siblings — the stack hands it down. */
export const PushStackIndexContext = createContext(0);
